<template>
	
	<el-row>
		
		<el-col :span="16" class="content-area__inner content-area__list no-padding">
			
			<ContentAreaTitle title="User Access">
				<template slot="actions">
					<el-button icon="el-icon-plus" @click="onClickAddUser" round>New User</el-button>
				</template>
			</ContentAreaTitle>
			
			<!--<div class="card card--border card--no-padding">-->
				<el-table empty-text="There are no users in the system." :data="users">
					<el-table-column type="expand">
						<template slot-scope="scope">
							<p class="more-info"><ion-icon name="mail"></ion-icon>{{ scope.row.email }}</p>
							<p class="more-info"><ion-icon name="call"></ion-icon>{{ scope.row.phone }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="Name">
						<template slot-scope="scope">
							<el-button type="text" :disabled="scope.row.id == $auth.user().id" @click="onClickUserName(scope.row.data)">{{ scope.row.name }}</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="role" label="Role"></el-table-column>
					<el-table-column prop="type" label="Group"></el-table-column>
				</el-table>
			<!--</div>-->
			
		</el-col>
		
		<el-col :span="8" class="content-area__inner content-area__right-column">
			<router-view :key="$route.fullPath"></router-view>
		</el-col>
		
	</el-row>
	
</template>

<script>

	import ContentAreaTitle from "@/components/ContentAreaTitle";
	
	export default {
		
		name: "UsersList",
		
		components: { ContentAreaTitle },
		
		data() {
			
			return {};
			
		},
		
		methods: {
			
			onClickAddUser() {
				this.$router.push({ name: "users" });
			},
			
			onClickUserName(userData) {
				this.$router.push({ name: "users/edit", params: { id: userData.id } });
			},
			
			onClickDeleteUser(userData) {
				this.$Notice.error({
					title: "Uh oh!",
					desc: "Can't delete user: " + userData.name,
				});
			}
			
		},
		
		computed: {
			
			users() {
				return this.$store.state.users.map(function(data, i) {
					return {
						id: data.id,
						name: data.name,
						role: data.role,
						type: data.type,
						email: data.email ? data.email : "N/A",
						phone: data.phone ? data.phone : "N/A",
						data: data,
					};
				});
			},
			
		},
		
		created() {
			
			this.$store.dispatch("getApiData", { key: "users" });
			
		},
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/Users/Users.vue